export default {
  data() {
    return {
      emailFocused: false,
      passFocused: false,
      codeFocused: false,
      firstNameFocused: false,
      secondNameFocused: false,
    };
  },
  methods: {
    fieldFocused(payload) {
      this[payload] = true;
    },
    fieldBlured(payload) {
      this[payload] = false;
    },
  },
};
